import { useState } from "react"
import useHashObserver from "./useHashObserver"
import useScrollToAndHighlight from "./useScrollToAndHighlight"

// This hook does 2 things (via its delegated hooks):
// 1. Observes the target element (or its specified children)
// to update the hash with the element's ID when it intersects the viewport
// 2. Scrolls to and highlight the element with the hash ID when the hash changes
// currently applies scroll and highlight on initial load
const useScrollToHashWithHashObserver = ({
  selector,
  shouldScroll = true
}: {
  selector: string
  shouldScroll?: boolean
}) => {
  const [isScrolling, setIsScrolling] = useState(false)

  // On first load or hash change, scroll to and highlight the element
  useScrollToAndHighlight({
    onScrollStart: () => setIsScrolling(true), // Start scrolling
    onScrollEnd: () => {
      setIsScrolling(false) // End scrolling
    },
    isActive: shouldScroll
  })

  // Observe elements for hash updates only after the initial scroll
  useHashObserver({ selector, isActive: !isScrolling })

  return null
}

export default useScrollToHashWithHashObserver
